import React, { useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Collapse } from 'reactstrap';

const CommonCollapse = ({ id, heading, children }) => {
  const [isOpen, setIsOpen] = useState({});
  const [isOpenCollapse, setIsOpenCollapse] = useState(false);

  const toggleCollapse = (index) => {
    setIsOpenCollapse(!isOpenCollapse);
    setIsOpen((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  return (
    <div>
      {' '}
      <div key={id}>
        <div
          color="primary"
          className="collapse-heading d-flex align-items-center justify-content-between mb-3"
          onClick={() => toggleCollapse(id)}
          aria-hidden
        >
          <span className="fw-medium">{heading}</span>
          {isOpenCollapse ? <IoIosArrowUp /> : <IoIosArrowDown />}
        </div>
        <Collapse isOpen={isOpen[id]}>{children}</Collapse>
      </div>
    </div>
  );
};

export default CommonCollapse;
